/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { Text } from '@chakra-ui/react';
import useStore from '../../../store';

const Q_USER = gql`
	query getUserById($id: String!) {
		getUserById(id: $id) {
			id
			username
			fullName
			fullNameKhmer
			department
		}
	}
`;

export default function EventLoggingName({ id = null }) {
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const [getUser, { data }] = useLazyQuery(Q_USER);

	useEffect(() => {
		if (id) {
			const variables = { id };
			getUser({ variables });
		}
	}, [id]);

	return (
		<Text fontSize="sm" fontWeight="md" color="gray.600">
			{data
				? lang === 'kh'
					? data?.getUserById?.fullNameKhmer
						? data?.getUserById?.fullNameKhmer
						: data?.getUserById?.fullName
						? data?.getUserById?.fullName
						: data?.getUserById?.username
					: data?.getUserById?.fullName
					? data?.getUserById?.fullName
					: data?.getUserById?.fullNameKhmer
					? data?.getUserById?.fullNameKhmer
					: data?.getUserById?.username
				: null}
		</Text>
	);
}
